class Utils {
  validateLightness (value) {
    return !value || (parseInt(value, 10) >= 50 && parseInt(value, 10) <= 900)
  }
}

export default Utils



// WEBPACK FOOTER //
// ./src/bcq-ui/mixins/utils.js